import { has, isArray, each } from 'lodash'
import store from 'vx/store'
import Vue from 'vue'

/**
 * Before each route we determine if the user has the necessary permissions to access the page
 * they are trying to get to.
 */
export default (to, from, next) => {
  let user = store.state.auth.user

  const is = (roles) => {
    if (!isArray(roles)) {
      roles = roles.split(',')
    }

    let isRole = false

    each(roles, (role) => {
      if (user.role === role) {
        isRole = true
      }
    })

    return isRole
  }

  if (has(to.meta, 'permissions')) {
    if (typeof to.meta.permissions === 'function') {
      if (!to.meta.permissions(user, is, to, from)) {
        Vue.noty.error('You do not have the necessary permission to perform this action.')

        next({ name: 'dashboard', replace: true })

        return
      }
    } else if (!is(to.meta.permissions)) {
      Vue.noty.error('You do not have the necessary permission to perform this action.')

      next({ name: 'dashboard', replace: true })

      return
    }
  }

  next()
}
